import React, { ReactNode } from "react";

import { IgDivider } from "@intelligems/ig-theme";
import { Box, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import { BaseMetricSectionHeader } from "@src/features/analytics/baseDashboard/BaseMetricSectionHeader";

interface BaseMetricSectionProps {
  groupTitle: string;
  children: ReactNode;
  showCompareGroups?: boolean;
  headerDropdown?: ReactNode;
  rightSideButtons?: ReactNode[];
  tooltip?: string;
}

export const BaseMetricSection = ({
  groupTitle,
  showCompareGroups,
  headerDropdown,
  children,
  rightSideButtons,
  tooltip,
}: BaseMetricSectionProps) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        borderTopLeftRadius: "10px",
        borderTopRightRadius: "10px",
        borderBottomLeftRadius: "10px",
        borderBottomRightRadius: "10px",
        backgroundColor: theme.igBackgroundColors.baseLightMid,
        border: `1px solid ${theme.igBorders.core.default}`,
      }}
    >
      <BaseMetricSectionHeader
        groupTitle={groupTitle}
        showCompareGroups={showCompareGroups}
        headerDropdown={headerDropdown}
        rightSideButtons={rightSideButtons}
        tooltip={tooltip}
      />
      <IgDivider
        sx={{
          border: `.5px solid ${theme.igBorders.core.default}`,
          height: "0px !important",
        }}
      />
      <Grid
        id={"grid-children-container"}
        container
        rowSpacing={3.2}
        columnSpacing={3.2}
        direction={"row"}
        sx={{ padding: "24px 30px" }}
      >
        {children}
      </Grid>
    </Box>
  );
};
